import { atom } from 'jotai'

export const isCcVisibleAtom = atom<boolean>(false)
export const isBccVisibleAtom = atom<boolean>(false)
